import { ProgressivePattern } from "@arction/lcjs";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { globals } from "../../../../../misc/globals";
import { forceRerenderUI, registerEttAttempt } from "../../../../../misc/tools";
import BasePracticeScenario from "../../../../base-practice-scenario/BasePracticeScenario";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import GeneralProceduresEttMain, { GeneralProceduresEttMainConfig, GeneralProceduresEttPart1Config } from "../GeneralProceduresEttMain";
var ettAttempts = 0;

export default class GeneralProceduresEttPart1 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresEttPart1Config {
		return this.scenarioConfig.part1Config;
	}
	constructor(private main: GeneralProceduresEttMain, private _scenario: DaarcBaseScenario, private onDone: () => void, private onAbort: () => void, private id: string, private scenarioConfig: GeneralProceduresEttMainConfig, public onDoneGoToEttOptimizations: () => void) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		this.step1SelectSize();
	}

	public step1SelectSize() {
		const context = this;
		context.scenario.uiWrapper.displayETTSizeUI({
            onNextClicked: (sizePicked: string) => {
				if(context.config.onEttSizeSelected) {
					context.config.onEttSizeSelected(sizePicked);
				}
                context.step2ShowAttemptWindow(sizePicked);
            }
        })
	}

	public step2ShowAttemptWindow(size: string) {
		const context = this;
		var hideVlButton = false;

		if(context.config.hideVlButton) {
			hideVlButton = context.config.hideVlButton();
		}

		context.scenario.uiWrapper.displayETTMakeAttemptUI({
			ettSize: size,
			hideVlButton: hideVlButton,
			onAbortedClicked: () => {
				if(context.onAbort) {
					context.onAbort();
				}
			},
			onMakeAttemptClicked: (isDLClicked: boolean, isVLClicked: boolean) => {
				registerEttAttempt(context.scenario);

				if(context.scenarioConfig.unableToCompletePopup) {
					context.scenario.uiWrapper.displayGeneralAlertUI({
						title: context.scenarioConfig.unableToCompletePopup.boxTitle,
						text: context.scenarioConfig.unableToCompletePopup.boxMessage,
						okButton: {
							title: 'OK',
							onClicked: () => {
								context.onDoneGoToEttOptimizations();
							}
						}
					});
					return;
				}

				if(context.config.onMakeAttemptClicked) {
					context.config.onMakeAttemptClicked(isDLClicked, isVLClicked);
				}
				context.step3ShowSpecialUI();
			}
        })
	}

	public step3ShowSpecialUI() {
		const context = this;
		var oldCallback = context.config.ettSpecialUIConfig.onNextClicked;
		context.config.ettSpecialUIConfig.onNextClicked = () => {
			if(oldCallback) {
				oldCallback();
			}
			context.step4ShowInsertionUI();
		};

		context.config.ettSpecialUIConfig.onAbortClicked = () => {
			context.scenario.toolbagId = context.scenario.uiWrapper.displayToolbag({
				isDisabled: false
			}, context.scenario.toolbagId);
			if(context.config.onAbortClicked) {
				context.config.onAbortClicked();
			}

			if(context.onAbort) {
				context.onAbort();
			}
		};
		context.scenario.uiWrapper.displayETTSpecialUI(context.config.ettSpecialUIConfig);
	}

	public step4ShowInsertionUI() {
		const context = this;

		context.scenario.uiWrapper.displayETTInstrumentInsertionUI({
			onNextClicked: (selectedIndex: number) => {
				if(context.config.onEttInstrumentInsertionNextClicked) {
					context.config.onEttInstrumentInsertionNextClicked(selectedIndex);
				}
				// context._scenario.addScore(context.scenario.ettInstrumentForInsertionPoints);
				context.step5ShowIndicator();
			},
			onAbortClicked: () => {
				context.scenario.toolbagId = context.scenario.uiWrapper.displayToolbag({
					isDisabled: false
				}, context.scenario.toolbagId);
				if(context.config.onAbortClicked) {
					context.config.onAbortClicked();
				}
			}
		});
	}

	public step5ShowIndicator() {
		const context = this;
		ettAttempts++; 
		if(context.config.onProcedureAttempted) {
			context.config.onProcedureAttempted(ettAttempts);
		}
		if(ettAttempts > 4) {
			ettAttempts = 4;
		}

		if(ettAttempts === 4) {
			if(context.config.onProcedureAttemptedMoreThan3Times) {
				context.config.onProcedureAttemptedMoreThan3Times();
			}
			// this._scenario.debriefLogFailedItem('You have attempted ETT more than 3');
		}

		var propName = 'intubationattempt';

		// switch(context.successType) {
		// 	case SuccessType.Failed:
		// 		propName += 'Failed';
		// 		break;
		// 	default:
		// 		propName += 'TempSuccess';
		// 		break;
		// }

		propName += ettAttempts;

		// context.playVideoChapter((context._videoChapters as any)[propName], () => {
		// })

		var nonDefaultAudio = (this.config as any)['attempt' + ettAttempts + 'AudioPath']
		context.scenario.auscultateAudio = nonDefaultAudio ?? './assets/audio/ett/' + propName +'.mp3'

		// context.scenario.gameManager.SoundManager.playSound({
		// 	src: nonDefaultAudio ?? './assets/audio/ett/' + propName +'.mp3',
		// 	autoPlay: true,
		// 	enableClosedCaptioning: false,
		// 	muted: false,
		// 	volume: 1
		// });


		var onDoneWithPopup = context._scenario.doSomething('Inserting ETT');
		setTimeout(() => {
			context.main.loopVideo(this, context.config.insertingETTVideoChapter());
			onDoneWithPopup();
			context.step6ShowEttInserted();
		}, constants.doSomethingTimeout);
	}

	public step6ShowEttInserted() {
		const context = this;
		if(context.scenarioConfig.ettResistanceConfig && context.scenarioConfig.ettResistanceConfig.show()) {
			var oldCallbak = context.scenarioConfig.ettResistanceConfig.onNextClicked;
			context.scenarioConfig.ettResistanceConfig.onNextClicked = (selectionIndx: number) => {
				if(oldCallbak) {
					oldCallbak(selectionIndx);
				}

				switch(selectionIndx) {
					case 0:
					case 1:
						context.step7SqueezeAmbuBag();
						break;
					case 2:
						context.scenario.toolbagId = context.scenario.uiWrapper.displayToolbag({
							isDisabled: false
						}, context.scenario.toolbagId);
						if(context.config.onAbortClicked) {
							context.config.onAbortClicked();
						}

						context.onAbort();
						break;
				}
			};
			context.scenario.uiWrapper.displayEttResistanceUI(context.scenarioConfig.ettResistanceConfig);
			return;
		}
		context.scenario.uiWrapper.displayGeneralAlertUI({
			title: 'Inserting ETT',
			text: 'ETT Inserted',
			hideBlackBg: true,
			okButton: {
				onClicked: () => {
					context.step7SqueezeAmbuBag();
				},
				title: 'Next'
			}
		});
	}

	public step7SqueezeAmbuBag() {
		const context = this;
		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>Squeezing Ambubag</p>`,
			onDismissed: () => {
				context.step8MovingAir();
			}
		})

		context.main.loopVideo(this, context.config.squeezeAmbuBagVideoChapter());

		if(context.scenarioConfig.isAttemptSuccessful()) {
			(context.scenario as BasePracticeScenario).stopApneaTimerForEntireRunThrough();
		} else if(context.scenarioConfig.isTempSuccess()) {
			(context.scenario as BasePracticeScenario).resetApneaTimerForEntire();
		}

	}

	public step8MovingAir() {
		const context = this;
		const isSuccessful = this.scenarioConfig.isAttemptSuccessful() || this.scenarioConfig.isTempSuccess();
		context._scenario.uiWrapper.displayNotificationUI({
			text: `<p class='notification-text'>${ isSuccessful ? 'Moving Air' : 'We\'re encountering some resistance.'}</p>`,
			onDismissed: () => {
			}
		})

		if(isSuccessful) {
			context.scenario.gameManager.SoundManager.playSound({
				src: './assets/audio/bvm/BVMmovingair.mp3',
				autoPlay: true,
				enableClosedCaptioning: false,
				muted: globals.isMuted,
				volume: 1
			});
		}
		
		context.onDone();
		// context.playVideoChapter(context._videoChapters.step4RTMovingAir, () => {
		// 	context.onDone();
		// })
	}
}